import { call, cancelled, put, take, takeLatest } from 'redux-saga/effects';
import { setOnlineStatus } from '../features/network.slice';
import { createOnlineOfflineChannel } from '../../hooks/useNetwork';
import { EventChannel, SagaIterator } from 'redux-saga';

export function* watchNetworkStatus():SagaIterator {
  const channel:EventChannel<boolean> = yield call(createOnlineOfflineChannel);
  console.log("vbn");

  try {
    while (true) {
      const checkOnlineStatus:boolean = yield take(channel);
      yield put(setOnlineStatus(checkOnlineStatus));
    }
  } catch (error) {
    console.error('Network monitoring error:', error);
  } finally {
    if (yield cancelled()) {
      channel.close();
    }
  }
}
